import { useLocalStorage } from 'usehooks-ts';

/**
 * UI design version switch.
 *
 * 'v2' — new CleverParking-based redesign (default),
 * 'v1' — legacy design.
 *
 * The choice is persisted in localStorage so a user can opt back to the
 * old version at any time. Read it in styled-components via
 * `props.theme.ui` (wired in `src/app/app.js`).
 */
const LOCAL_STORAGE_KEY = 'caps-ui-version2';
export const UI_V1 = 'v1';
export const UI_V2 = 'v2';

export function useUiVersion() {
  const [version, setVersion] = useLocalStorage(LOCAL_STORAGE_KEY, UI_V1);

  const isNew = version !== UI_V1;

  return {
    version: isNew ? UI_V2 : UI_V1,
    isNew,
    toggle: () => setVersion((prev) => (prev === UI_V1 ? UI_V2 : UI_V1)),
    setVersion,
    useNew: () => setVersion(UI_V2),
    useOld: () => setVersion(UI_V1),
  };
}
